import { PhotoItem } from '../Card';
import { DisplayButton } from '@xo-union/tk-ui-links';
import Spinner from '@xo-union/tk-component-spinner';
import Honeybadger from 'honeybadger-js';
import React from 'react';

import { GifItemsFragment, useDeleteGifItemMutation } from '../../generated/graphql';
import deletePageItem from '../../helpers/apolloCache/deletePageItem';
import { ItemProps } from './common';
import styles from './photoGallery.scss';

const Gif: React.FC<ItemProps> = ({ item, page, className, dragProps }) => {
  const [deleteGif, { loading }] = useDeleteGifItemMutation();
  const photo = item as GifItemsFragment;
  const itemId = item.id;
  const pageId = page.id;

  const onDelete = async () => {
    try {
      await deleteGif({
        variables: { attributes: { id: itemId, pageId } },
        update(cache) {
          deletePageItem({ pageId, itemId, cache });
        },
      });
    } catch (error) {
      Honeybadger.notify(error, {
        message: 'Error deleteing GifItem',
        context: {
          error,
        },
      });
    }
  };

  return (
    <>
      <div data-testid={`gif-item-${itemId}`}>
        <PhotoItem
          title="Gif"
          rightElement={
            <div className={styles.editContainer}>
              {loading ? (
                <Spinner />
              ) : (
                <DisplayButton iconName="delete" color="primary" onClick={onDelete}>
                  Remove
                </DisplayButton>
              )}
            </div>
          }
          photoPath={photo.mediaUrl}
          className={className}
          {...dragProps}
        />
      </div>
    </>
  );
};

export default Gif;
